import { useEffect, useState } from "react";
import { ProductService } from "../../../services";


const usePrivacyPolicy = () => {
    const [privacyData, setPrivacyData] = useState<any>("");
    const [loaderdata, setLoaderdata] = useState("notset");
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    /**
     * privacy policy api call
     */
    useEffect(() => {
        ProductService.privacyPolicy().then((response) => {
            setLoaderdata("isfull");
            setPrivacyData(response)
        })
    }, [])
    return {
        privacyData,
        loaderdata
    }
}
export default usePrivacyPolicy;